import React from 'react'
import { Checkbox, Icon } from 'antd'

const CloningSection = ({
  t,
  data,
  isCheckAll,
  onCheckAll,
  onCheckOne,
  isNoLessonSelected,
  isVoiceRequiredMissing,
  isTranslaton
}) => {
  const courseLessons = Array.isArray(data.courseLessons) ? data.courseLessons : []
  const selectedLessonCount = courseLessons.filter(lesson => lesson.isChecked).length
  const totalLessonCount = data.totalLesson || courseLessons.length
  const isPartiallySelected =
    selectedLessonCount > 0 && selectedLessonCount < totalLessonCount

  return (
    <div className="clone-cloning-panel">
      <div className="section-head">
        <h3>Lesson Selection</h3>
        <Checkbox
          onChange={onCheckAll}
          checked={isCheckAll}
          indeterminate={isPartiallySelected}
        >
          {t('labels:Lessons')} ({selectedLessonCount}/{totalLessonCount})
        </Checkbox>
      </div>

      <div className="status-area">
        {isNoLessonSelected && (
          <div className="status-row">
            <Icon type="warning" className="warningIcon" />
            <label>
              {isTranslaton
                ? 'Please add at least one lesson in order to translate this course.'
                : t('course:clonning_no_lesson')}
            </label>
          </div>
        )}
        {isVoiceRequiredMissing && (
          <div className="status-row">
            <Icon type="warning" className="warningIcon" />
            <label>{t('v4:voice_must_be_selected')}</label>
          </div>
        )}
      </div>

      <div className="lessons-list">
        {courseLessons.map((lesson, index) => (
          <Checkbox
            onChange={() => onCheckOne(lesson)}
            className="lesson-box"
            key={index}
            checked={lesson.isChecked}
          >
            {t('labels:clone_of')} - {lesson.title}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

export default CloningSection
